// @flow
import type { Dispatch } from '../types';
import * as constants from '../constants/targetConstants';
import { SECTION } from '../constants/appConstants';
import appActions from './appActions';

export default {
    selectThunk: (target: null | $ReadOnly<{id: string, type: $Values<typeof constants.TYPE>}>) => (dispatch: Dispatch) => {
        dispatch(appActions.setTarget(target));

        if(target) {
            dispatch(appActions.setSection(SECTION.targetInspector ));
        }
    }
};